// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2ioFu","emails":"CreateEditClinics_emails__2H0Fe","emailTagLabel":"CreateEditClinics_emailTagLabel__1DGCR"};